import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { FormControl } from "baseui/form-control";
import { Input } from "baseui/input";
import { Checkbox } from "baseui/checkbox";
import { RadioGroup, Radio, ALIGN } from "baseui/radio";
import { Button } from "baseui/button";
import {
	Modal,
	ModalHeader,
	ModalBody,
	ModalFooter,
	ModalButton,
} from "baseui/modal";
import { Datepicker } from "baseui/datepicker";
import { Notification } from "baseui/notification";
import request from "../../utils/http";
import toaster from "../../utils/toaster";
import TwoColumnGrid from "../../components/grid/TwoColumnGrid";
import { useNavigate,useParams } from "react-router-dom";
import AppContext from "../../AppContext";
import { Select } from "baseui/select";
import enums from "../../utils/enums";
import { dateFromDateArray, zonelessIsoDate } from "../../utils/date";
import { radio } from "aws-amplify";
import { Spinner } from "baseui/spinner";
import Copy from "../../components/Copy";
import { CandidateSite } from "../../models/Candidate";
import { Textarea } from "baseui/textarea";

const Container = styled.div`
	label.required::after {
		content: " *";
		color: red;
`;

const SiteDaysContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
	grid-column-gap: 1rem;
`;

const GridSpacer = styled.div`
	margin-top: 1rem;
	display: grid;
	grid-row-gap: 1rem;
`;

const StyledSelect = styled(Select)`
	width: 40%;
`;

const CandidateEdit = () => {
	const [pilAccess,setPILAccess] = useState(Boolean);
	const [allPositions,setAllPosiitons] = useState([] as any);

	const loadPILAccess = async () => {
		let result = await request(
			"GET",
			`/api/admin/utility/pil-permission-get`,
			null
		);
		if (result.success && result.data) {
			if(!result.data.pilAccess)
			{
				toaster.error("You don't have permission to create a PIL candidate");
			}
			setPILAccess(result.data.pilAccess);
		}
	};

	const getZambionPositions = async () => {
		let result = await request(
			"GET",
			"/api/admin/candidate-zambion/positions",
			null,
			true,
			false
		);
		if (result.success && result.data?.positions) {
			setAllPosiitons(result.data.positions);
		} else {
			toaster.error("Unable to access positions");
		}
	};

	const navigate = useNavigate();
	const appContext = useContext(AppContext);

	const [allOnboardingTaskSets, setAllOnboardingTaskSets] = useState(
		null as any
	);
	const [allEmploymentAgreements, setAllEmploymentAgreements] = useState(
		null as any
	);
	const [allPositionDescriptions, setAllPositionDescriptions] = useState(
		null as any
	);
	const [jobCodes, setJobCodes] = useState([] as any);
	const [jobCodeRates, setJobCodeRates] = useState([] as any);
	const urlParams = useParams() as any;

	useEffect(() => {
		const fetchCandidateAsync = async () => {
			fetchCandidate();
			// if (candidateSites == null || candidateSites.length == 0) {
			// 	setCandidateSites([
			// 		{
			// 			jobCodeRate: hourlyRate,
			// 			siteId: 1,
			// 			customHourlyRate: customHourlyRate,
			// 		} as CandidateSite,
			// 	]);
			// }
		}

		fetchCandidateAsync();
	}, [urlParams.candidateId]);

	useEffect(() => {
		loadPILAccess();
		getZambionPositions();
		getCandidateTaskSets();
		getCandidateEmploymentAgreements();
		getAllPositionDescriptions();
		// loadJobCodes({ pageNumber: 1, pageSize: 2000, searchText: "" });
		// loadJobCodeRates();
		getAdminUsers();
	}, []);

	const getCandidateTaskSets = async () => {
		let result = await request(
			"GET",
			"/api/admin/utility/candidate/pil-task-sets",
			null,
			true,
			false
		);
		if (result.success) {
			setAllOnboardingTaskSets(result.data);
			// let tmpSelectedTaskSets = [];
			// for (let taskSet in result.data.items) {
			// 	if (result.data.items[taskSet].default) {
			// 		tmpSelectedTaskSets.push(result.data.items[taskSet].identifier);
			// 	}
			// }
			// setSelectedTaskSets(tmpSelectedTaskSets);
		} else {
			toaster.error("Unable to access onboarding tasks");
		}
	};

	const getCandidateEmploymentAgreements = async () => {
		let result = await request(
			"GET",
			"/api/admin/utility/candidate/employment-agreements",
			null,
			true,
			false
		);
		if (result.success) {
			let filteredEmploymentAgreements = [] as Array<any>;

			for (let employmentAgreement in result.data.items) {
				if (result.data.items[employmentAgreement].slug.includes("pil-")) {
					filteredEmploymentAgreements.push(
						result.data.items[employmentAgreement]
					);
				}
			}
			setAllEmploymentAgreements(filteredEmploymentAgreements);

			let tmpAvailableEmploymentAgreements = [] as Array<string>;

			for (let employmentAgreement in filteredEmploymentAgreements) {
				if (filteredEmploymentAgreements[employmentAgreement].default) {
					tmpAvailableEmploymentAgreements.push(
						filteredEmploymentAgreements[employmentAgreement].identifier
					);
				}
			}

			setAvailableEmploymentAgreements(tmpAvailableEmploymentAgreements);
			setDefaultEmploymentAgreements(tmpAvailableEmploymentAgreements);

			let tmpHolidayVisaEmploymentAgreements = [] as Array<string>;

			for (let employmentAgreementHV in filteredEmploymentAgreements) {
				if (filteredEmploymentAgreements[employmentAgreementHV].workingHolidayDefault) {
					tmpHolidayVisaEmploymentAgreements.push(
						filteredEmploymentAgreements[employmentAgreementHV].identifier
					);
				}
			}
			setHolidayVisaEmploymentAgreements(tmpHolidayVisaEmploymentAgreements);
		} else {
			toaster.error("Unable to access employment agreements");
		}
	};

	const getAllPositionDescriptions = async () => {
		let result = await request(
			"GET",
			"/api/admin/asset-file/all/PositionDescription",
			null,
			true,
			false
		);
		if (result.success) {
			setAllPositionDescriptions(result.data.files);
		} else {
			toaster.error("Unable to access position descriptions");
		}
	};

	// interface LoadJobCodesParams {
	// 	pageNumber: number;
	// 	pageSize: number;
	// 	searchText: string;
	// }

	// const loadJobCodes = async ({
	// 	pageNumber,
	// 	pageSize,
	// 	searchText,
	// }: LoadJobCodesParams) => {
	// 	try {
	// 		const params = new URLSearchParams({
	// 			pageNumber: pageNumber.toString(),
	// 			pageSize: pageSize.toString(),
	// 			searchText,
	// 		});

	// 		const url = `/api/admin/jobcode?${params.toString()}`;
	// 		const result = await request("GET", url, null);

	// 		if (result.success && result.data) {
	// 			const activeJobCodes = result.data.jobCodes.filter(
	// 				(code: { active: boolean }) => code.active
	// 			);
	// 			setJobCodes(activeJobCodes);
	// 		}
	// 	} catch (error) {
	// 		// Handle error loading job codes.
	// 	}
	// };

	// const loadJobCodeRates = async () => {
	// 	try {
	// 		const result = await request("GET", "/api/admin/jobcoderate", null);

	// 		if (result.success && result.data) {
	// 			const activeJobCodeRates = result.data.jobCodeRates.filter(
	// 				(rate: { active: boolean }) => rate.active
	// 			);
	// 			setJobCodeRates(activeJobCodeRates);
	// 		}
	// 	} catch (error) {
	// 		// Handle error loading job codes.
	// 	}
	// };
	const [loaded, setLoaded] = useState(false);

	const [firstName, setFirstName] = useState("");
	const [lastName, setLastName] = useState("");
	const [contactEmail, setContactEmail] = useState("");
	const [contactMobile, setContactMobile] = useState("");

	const [replacingName, setReplacingName] = useState("");
	const [replacingTerminated, setReplacingTerminated] = useState(false);

	const [isWorkingHoliday, setIsWorkingHoliday] = useState(false);
	const [previouslyWorked, setPreviouslyWorked] = useState(false);
	const [previouslyWorkedComment, setPreviouslyWorkedComment] = useState("");
	const [previouslyWorkedPinNumber, setPreviouslyWorkedPinNumber] = useState(0);
	const [availableFullTime, setAvailableFullTime] = useState(false);
	const [availablePartTime, setAvailablePartTime] = useState(false);
	const [partTimeConfirm, setPartTimeConfirm] = useState(false);

	const [position, setPosition] = useState<any>([]);
	const [positionDescriptionValue, setPositionDescriptionValue] = useState<any>(
		[]
	);

	const [hepBMonitoringRequired, setHepBMonitoringRequired] = useState(false);
	const [drivingCompanyVehicle, setDrivingCompanyVehicle] = useState(false);
	const [vehicleAllowancePolicy, setVehicleAllowancePolicy] = useState(false);
	const [kerbsideCollection, setKerbsideCollection] = useState(false);
	const [waterBlasting, setWaterBlasting] = useState(false);
	const [workingAtPublicSchool, setWorkingAtPublicSchool] = useState(false);
	const [workingAtPublicSchoolWeeksValue, setWorkingAtPublicSchoolWeeksValue] =
		useState<any>([]);
	const [hourlyRate, setHourlyRate] = useState(0);
	const [salary, setSalary] = useState(0);
	const [customHourlyRate, setCustomHourlyRate] = useState(false);
	const [customHourlyRateValue, setCustomHourlyRateValue] = useState(0);
	const [customHourlyRateReason, setCustomHourlyRateReason] = useState("");
	const [reasonForAgreement, setReasonForAgreement] = useState("");
	const [approvedByRegionalManager, setApprovedByRegionalManager] =
		useState("");
	const [employmentTypeValue, setEmploymentTypeValue] = useState<any>([]);
	const [availableEmploymentAgreements, setAvailableEmploymentAgreements] =
		useState([] as Array<string>);
	const [holidayVisaEmploymentAgreements, setHolidayVisaEmploymentAgreements] =
		useState([] as Array<string>);
	const [defaultEmploymentAgreements, setDefaultEmploymentAgreements] =
		useState([] as Array<string>);

	const [candidateSites, setCandidateSites] = useState(
		[] as Array<CandidateSite>
	);

	const [daysOfWorkPerWeek, setDaysOfWorkPerWeek] = useState(0);
	const [hoursOfWorkPerDay, setHoursOfWorkPerDay] = useState(0);
	const [timeOfWork, setTimeOfWork] = useState("");
	const [basedAt, setBasedAt] = useState("");
	const [workTool, setWorkTool] = useState("");
	const [requiredInExcessOf10HoursPerDay, setRequiredInExcessOf10HoursPerDay] =
		useState(false);
	const [fixedTermEndDate, setFixedTermEndDate] = useState(null as any);
	const [companyBenefit, setCompanyBenefit] = useState("");
	const [startDate, setStartDate] = useState(null as any);
	const [managerName, setManagerName] = useState("");
	const [managerContactNumber, setManagerContactNumber] = useState("");
	const [hiringManagerName, setHiringManagerName] = useState("");
	const [hiringManagerContactNumber, setHiringManagerContactNumber] =
		useState("");
	const [ppcsConfirmed, setPpcsConfirmed] = useState(false);

	const [selectedTaskSets, setSelectedTaskSets] = useState([] as Array<string>);

	const [isSaving, setIsSaving] = useState(false);

	const [candidateCreated, setCandidateCreated] = useState(false);
	const [candidate, setCandidate] = useState(null as any);
	const [adminUsers, setAdminUsers] = useState([] as any);
	const [allocatedTo, setAllocatedTo] = useState<any>([]);
	const [workRegion, setWorkRegion] = useState("");

	const [fieldsChanged, setFieldsChanged] =	useState([] as Array<string>);
	const pushFieldChanged = (value: string) => {
		let tmpFeildList = [...fieldsChanged];
		let tmpFeildName = value.charAt(0).toUpperCase()+value.slice(1);
		if(tmpFeildList.indexOf(tmpFeildName)==-1)
		{
			tmpFeildList = [...tmpFeildList, tmpFeildName];
		}
		setFieldsChanged(tmpFeildList);
	};

	interface FieldErrors {
		[key: string]: string;
	}

	const [fieldErrors, setFieldErrors] = useState<FieldErrors>({
		hiringManagerName: "",
		hiringManagerContactNumber: "",
		firstName: "",
		lastName: "",
		contactEmail: "",
		// previouslyWorkedPinNumber: "",
		// previouslyWorkedComment: "",
		position: "",
		positionDescriptionValue: "",
		//hourlyRate: "",
		// salary: "",
		// customHourlyRateValue: "",
		// customHourlyRateReason: "",
		employmentTypeValue: "",
		approvedByRegionalManager: "",
		// candidateSites: "",
		// siteJobCode: "",
		// siteJobCodeRate: "",
		// siteCustomJobCodeRate: "",
		// siteCustomJobCodeRateReason: "",	
		// startDate: "",
		// fixedTermEndDate: "",
		daysOfWorkPerWeek: "",
		hoursOfWorkPerDay: "",
		timeOfWork: "",
		basedAt: "",
		managerName: "",
		managerContactNumber: "",
		allocatedTo: "",
		ppcsConfirmed: "",
		workRegion: "",
	});

	const [requiredFields, setRequiredFields] = useState([
		"hiringManagerName",
		"hiringManagerContactNumber",
		"firstName",
		"lastName",
		"contactEmail",
		// "previouslyWorkedPinNumber",
		// "previouslyWorkedComment",
		"position",
		"positionDescriptionValue",
		//"hourlyRate",
		// "salary",
		// "customHourlyRateValue",
		// "customHourlyRateReason",
		"employmentTypeValue",
		"approvedByRegionalManager",
		// "candidateSites[0].jobCode",
		// "candidateSites[0].jobCodeRate",
		"daysOfWorkPerWeek",
		"hoursOfWorkPerDay",
		"timeOfWork",
		"basedAt",
		"managerName",
		"managerContactNumber",
		"allocatedTo",
		"ppcsConfirmed",
		"workRegion",
	]);

	const addCandidateSiteFields = (index: number) => {
		const candidateSiteFields = [
			`candidateSites[${index}].jobCode`,
			`candidateSites[${index}].jobCodeRate`,
		];

		const newRequiredFields = [...requiredFields, ...candidateSiteFields];
		setRequiredFields(newRequiredFields);
	};

	const validateForm = () => {
		const errors: { [key: string]: string } = {};

		if (!hiringManagerName.trim()) {
			errors.hiringManagerName = "Hiring Manager Name is required";
		}

		if (!hiringManagerContactNumber.trim()) {
			errors.hiringManagerContactNumber =
				"Hiring Manager Contact Number is required";
		}

		if (!firstName.trim()) {
			errors.firstName = "First Name is required";
		}

		if (!lastName.trim()) {
			errors.lastName = "Last Name is required";
		}

		if (!contactEmail.trim()) {
			errors.contactEmail = "Email is required";
		}

		// if (previouslyWorked && previouslyWorkedPinNumber === 0) {
		// 	errors.previouslyWorkedPinNumber = "Previous PPCS pin number is required";
		// }

		// if (previouslyWorked && !previouslyWorkedComment.trim()) {
		// 	errors.previouslyWorkedComment =
		// 		"Reason for previously leaving PPCS is required";
		// }

		if (position.length == 0) {
			errors.position = "Position is required";
		}

		if (positionDescriptionValue.length === 0) {
			errors.positionDescriptionValue = "Job Description is required";
		}

		// if (hourlyRate === 0) {
		// 	errors.hourlyRate = "Hourly Rate is required";
		// }

		// if (salary === 0) {
		// 	errors.salary = "Salary is required";
		// }

		if (employmentTypeValue.length == 0) {
			errors.employmentTypeValue = "Employment type is required";
		}

		if (!workRegion.trim()) {
			errors.workRegion = "Work region is required";
		}

		if (!approvedByRegionalManager) {
			errors.approvedByRegionalManager = "Regional Manager is required";
		}

		if (!candidateSites) {
			errors.candidateSites = "Candidate site information is required";
		}
		// candidateSites.forEach((site, index) => {
		// 	if (!site.jobCode?.trim()) {
		// 		errors[`candidateSites[${index}].jobCode`] = `Job Code for Site ${
		// 			index + 1
		// 		} is required`;
		// 	}
		// 	if (typeof site.jobCodeRate !== "number" || isNaN(site.jobCodeRate)) {
		// 		errors[
		// 			`candidateSites[${index}].jobCodeRate`
		// 		] = `Hourly Rate for Site ${index + 1} is required`;
		// 	}
		// 	if (site.customHourlyRate && !site.reasonForOtherRate?.trim()) {
		// 		errors[
		// 			`candidateSites[${index}].reasonForOtherRate`
		// 		] = `Reason for Custom Hourly Rate on Site ${index + 1} is required`;
		// 	}
		// 	// Add additional validation for the "reasonForOtherRate" field if needed
		// });

		// candidateSites.forEach((site, index) => {
		// 	if (!site.jobCode?.trim()) {
		// 		errors[`candidateSites[${index}].jobCode`] = `Job Code for Site ${
		// 			index + 1
		// 		} is required`;
		// 	}
		// 	if (typeof site.jobCodeRate !== "number" || isNaN(site.jobCodeRate)) {
		// 		errors[
		// 			`candidateSites[${index}].jobCodeRate`
		// 		] = `Hourly Rate for Site ${index + 1} is required`;
		// 	}
		// 	if (site.customHourlyRate && !site.reasonForOtherRate?.trim()) {
		// 		errors[
		// 			`candidateSites[${index}].reasonForOtherRate`
		// 		] = `Reason for Custom Hourly Rate on Site ${index + 1} is required`;
		// 	}
		// });
		// if (!startDate) {
		// 	errors.startDate = "Start Date is required";
		// }

		// if (!fixedTermEndDate) {
		// 	errors.fixedTermEndDate = "Fixed Term End Date is required";
		// }

		//disabled 11.02.2026 Start
		// if (daysOfWorkPerWeek == 0) {
		// 	errors.daysOfWorkPerWeek = "Days Of Work Per Week is required";
		// }

		// if (hoursOfWorkPerDay == 0) {
		// 	errors.hoursOfWorkPerDay = "Hours Of Work Per Day is required";
		// }
		//disabled 11.02.2026 End

		if (!timeOfWork.trim()) {
			errors.timeOfWork = "Time Of Work is required";
		}

		if (!basedAt.trim()) {
			errors.basedAt = "Base office is required";
		}

		if (!managerName.trim()) {
			errors.managerName = "Supervisor / Manager Name is required";
		}

		if (!managerContactNumber.trim()) {
			errors.managerContactNumber =
				"Supervisor / Manager Contact Number is required";
		}
		if (allocatedTo.length === 0) {
			errors.allocatedTo = "Allocated To is required";
		}

		if (!ppcsConfirmed) {
			errors.ppcsConfirmed =
				"Please confirm that correct details have been loaded";
		}

		setFieldErrors({
			...fieldErrors,
			...errors,
		});
		return Object.keys(errors).length === 0;
	};

	const validateAndSave = async () => {
		const isFormValid = validateForm();

		if (isFormValid) {
			await saveCandidate();
		} else {
			toaster.error("Please fill in all required fields");
		}
	};

	const getAdminUsers = async () => {
		let result = await request(
			"GET",
			`/api/admin/utility/admin-pil-users`,
			null,
			true,
			false
		);
		if (result.success && result.data?.users) {
			setAdminUsers(result.data.users);
		} else {
			toaster.error("Unable to load admin PIL users");
		}
	};

	const fetchCandidate = async () => {
		let result = await request(
			"GET",
			`/api/admin/candidate/${urlParams.candidateId}`,
			null
		);

		if (result.data) {
			const response = result.data.fields;
			setFirstName(response["Candidate.FirstName"]);
			setLastName(response["Candidate.LastName"]);
			setContactEmail(response["Candidate.ContactEmail"]);
			setContactMobile(response["Candidate.ContactMobile"]);

			setPosition([
				{
					value: response["CandidateAddendum.Position"],
					label: response["CandidateAddendum.Position"],
				},
			]);
			
			//setPreviouslyWorked(response["CandidateInternal.PreviouslyWorked"]);
			setHiringManagerName(response["CandidateAddendum.HiringManagerName"]);
			setHiringManagerContactNumber(response["CandidateAddendum.HiringManagerContactNumber"]);
			setEmploymentTypeValue([
				{
					value: response["CandidateInternal.EmploymentType"],
					label: response["CandidateInternal.EmploymentType.ToString"],
				},
			]);
			setWorkRegion(response["CandidateAddendum.WorkRegion"]);

			// setAvailableFullTime(response["CandidateInternal.AvailableFullTime"]);
			// setAvailablePartTime(response["CandidateInternal.AvailablePartTime"]);
			// setPartTimeConfirm(response["CandidateInternal.PartTimeConfirm"]);

			// setReplacingName(response["CandidateInternal.ReplacingName"]);
			// setReplacingTerminated(response["CandidateInternal.ReplacingTerminated"]);
			// setIsWorkingHoliday(response["CandidateInternal.IsWorkingHoliday"]);

			// setPreviouslyWorked(response["CandidateInternal.PreviouslyWorked"]);

			// setPreviouslyWorkedComment(response["CandidateInternal.PreviouslyWorkedComment"]);
			// setPreviouslyWorkedPinNumber(parseInt(response["CandidateInternal.PreviouslyWorkedPinNumber"]));
			
			setPositionDescriptionValue([
				{
					id: response["CandidateAddendum.PositionDescription"].id,
					name: response["CandidateAddendum.PositionDescription"].name,
				},
			]);
		
			// setHepBMonitoringRequired(response["CandidateInternal.HepBMonitoringRequired"]);
			setDrivingCompanyVehicle(response["CandidateInternal.DrivingCompanyVehicle"]);
			setVehicleAllowancePolicy(response["CandidateInternal.VehicleAllowancePolicy"]);
			// setKerbsideCollection(response["CandidateInternal.KerbsideCollection"]);
			// setWaterBlasting(response["CandidateInternal.WaterBlasting"]);
			// setWorkingAtPublicSchool(response["CandidateInternal.WorkingAtPublicSchool"]);

			// if(response["CandidateInternal.WorkingAtPublicSchoolWeeks"] != 0)
			// {
			// 	setWorkingAtPublicSchoolWeeksValue([
			// 		{
			// 			value:response["CandidateInternal.WorkingAtPublicSchoolWeeks"],
			// 			label:enums.schoolCleanerWeeks[response["CandidateInternal.WorkingAtPublicSchoolWeeks"]],
			// 		}
			// 	]);
			// }

			// let reasonForOtherRate = response["CandidateAddendum.ReasonForOtherRate"];
			// if (reasonForOtherRate != undefined && reasonForOtherRate.length > 0)
			// {
			// 	setCustomHourlyRate(true);
			// 	setCustomHourlyRateValue(response["CandidateAddendum.HourlyRate"]);
			// }
			// else
			// {
			// 	setHourlyRate([
			// 		{
			// 			jobCodeRate: response["CandidateAddendum.HourlyRate"],
			// 		}
			// ]);
			// }
			// setCustomHourlyRateReason(reasonForOtherRate);
			setHourlyRate(response["CandidateAddendum.HourlyRate"]);
			setSalary(response["CandidateAddendum.Salary"]);
			setWorkRegion(response["CandidateInternal.WorkRegion"]);

			setReasonForAgreement(response["CandidateAddendum.ReasonForAgreement"]);
			setApprovedByRegionalManager(response["CandidateInternal.ApprovedByRegionalManager"]);

			setAvailableEmploymentAgreements(response["CandidateInternal.AvailableEmploymentAgreements"]);
			
			// const responseSites = result.data.sites;
			// responseSites.forEach((site: CandidateSite) => {
			// 	if (site.reasonForOtherRate != undefined && site.reasonForOtherRate.length > 0)
			// 	{
			// 		site.customHourlyRate = true;
			// 	}
			// });
			// setCandidateSites(responseSites);

			setDaysOfWorkPerWeek(response["CandidateAddendum.DaysOfWorkPerWeek"]);
			setHoursOfWorkPerDay(response["CandidateAddendum.HoursOfWorkPerDay"]);
			setTimeOfWork(response["CandidateAddendum.TimeOfWork"]);
			setBasedAt(response["CandidateAddendum.BasedAt"]);
			setWorkTool(response["CandidateAddendum.WorkTool"]);
			// setRequiredInExcessOf10HoursPerDay(response["CandidateAddendum.RequiredInExcessOf10HoursPerDay"]);

			let startDateString = response["CandidateAddendum.StartDate"];
			if(startDateString != null)
			{
				setStartDate(new Date(startDateString));
			}
			
			let fixedTermEndDateString = response["CandidateAddendum.FixedTermEndDate"];
			if(fixedTermEndDateString != null)
			{
				setFixedTermEndDate(new Date(fixedTermEndDateString));
			}
			setCompanyBenefit(response["CandidateAddendum.CompanyBenefit"]);
			setManagerName(response["CandidateAddendum.ManagerName"]);
			setManagerContactNumber(response["CandidateAddendum.ManagerContactNumber"]);

			const responseTaskSets = result.data.taskSets;
			let tmpSelectedTaskSets = [];
			for (let taskSet in responseTaskSets) {
				let tsID = responseTaskSets[taskSet].taskSetId;
				tmpSelectedTaskSets.push(tsID);
			}
			setSelectedTaskSets(tmpSelectedTaskSets);
			setAllocatedTo([{id : response["Candidate.AllocatedToId"], name : response["Candidate.AllocatedToName"]}]);

			setLoaded(true);
		}
	};

	const PositionDescriptionMap = (resp: any) => {
		getAllPositionDescriptions();
		let PositionDescriptionObj = resp;
		allPositionDescriptions.forEach((fileObj: any) => {
			if(fileObj.id == PositionDescriptionObj.id)
			{
				setPositionDescriptionValue([{
					value: fileObj.id,
					label: fileObj.name,
				},])
			}		
		});
	};

	const saveCandidate = async () => {
		setIsSaving(true);

		let result = await request(
			"POST",
			"/api/admin/candidate/edit",
			{
				candidateId:urlParams.candidateId,
				fieldsChanged,
				candidateInternal: {
					firstName,
					lastName,
					contactEmail,
					contactMobile,
					replacingName,
					replacingTerminated,
					previouslyWorked,
					previouslyWorkedComment,
					previouslyWorkedPinNumber,
					availableFullTime,
					availablePartTime,
					partTimeConfirm,
					hepBMonitoringRequired,
					drivingCompanyVehicle,
					vehicleAllowancePolicy,
					kerbsideCollection,
					waterBlasting,
					workingAtPublicSchool,
					workingAtPublicSchoolWeeks:
						workingAtPublicSchoolWeeksValue.length == 1
							? workingAtPublicSchoolWeeksValue[0].value
							: 0,
					approvedByRegionalManager,
					employmentType:
						employmentTypeValue.length == 1
							? employmentTypeValue[0].value
							: null,
					candidateType: "PIL", //HN Placeholder for splitting to PIL or other candidate types.
					workRegion,
					availableEmploymentAgreements,
					isWorkingHoliday,
				},
				candidateAddendum: {
					position:
						position.length == 1
							? position[0].value
							: null,
					hourlyRate,
					salary,
					reasonForOtherRate: customHourlyRate ? customHourlyRateReason : null,
					reasonForAgreement,
					startDate: zonelessIsoDate(dateFromDateArray(startDate)),
					fixedTermEndDate: zonelessIsoDate(dateFromDateArray(fixedTermEndDate)),
					managerName,
					managerContactNumber,
					ppcsConfirmed,
					daysOfWorkPerWeek,
					hoursOfWorkPerDay,
					timeOfWork,
					basedAt,
					workTool,
					companyBenefit,
					requiredInExcessOf10HoursPerDay,
					positionDescriptionFileId:
						positionDescriptionValue.length == 1
							? positionDescriptionValue[0].id
							: null,
					hiringManagerName,
					hiringManagerContactNumber,					
				},
				candidate: {
					allocatedTo:
					allocatedTo.length == 1
					? allocatedTo[0].id
					: null,
				},
				candidateSites,
				selectedTaskSets,
			},
			true,
			false
		);
		if (result.success) {
			setCandidate(result.data);
			setCandidateCreated(true);
			allDone();
		} else if (result.message) {
			toaster.error(result.message);
		} else {
			toaster.error("An error occured while saving");
		}
		setIsSaving(false);
	};

	const allDone = () => {
		navigate({
			pathname: `/candidates`,
		});
	};

	const holidayVisaEmploymentAgreementsSelect = async () => {
		//reset all
		setAvailableEmploymentAgreements([]);
	};

	const defaultEmploymentAgreementsSelect = async () => {
		//default selection
		let tmpAvailableEmploymentAgreements = defaultEmploymentAgreements;

		for (let defEmploymentAgreement in availableEmploymentAgreements) {
			if (
				tmpAvailableEmploymentAgreements.indexOf(defEmploymentAgreement) > -1
			) {
				tmpAvailableEmploymentAgreements.splice(
					tmpAvailableEmploymentAgreements.indexOf(defEmploymentAgreement),
					1
				);
			} else {
				tmpAvailableEmploymentAgreements.push(defEmploymentAgreement);
			}
		}

		setAvailableEmploymentAgreements(tmpAvailableEmploymentAgreements);
	};

	const getLabel = ({ option }: any) => {
		return (
			<React.Fragment>
				{`${option.jobCode} - ${option.jobCodeName}`}
			</React.Fragment>
		);
	};

	const getSiteJobCodeError = (index: number) => {
		const key = `candidateSites[${index}].jobCode`;
		return fieldErrors[key];
	};

	const getSiteJobCodeRateError = (index: number) => {
		const key = `candidateSites[${index}].jobCodeRate`;
		return fieldErrors[key];
	};

	const getSiteReasonForCustomRateError = (index: number) => {
		const key = `candidateSites[${index}].reasonForOtherRate`;
		return fieldErrors[key];
	};

	const accessCheck = () => {

	}

	if(!pilAccess) {
		return ( <Container></Container> )	
	}
	else
	{
	return (
		<Container>
			<h1>
				Edit Candidate: 
				{firstName}{" "}
				{lastName}
			</h1>
			<hr />
			<TwoColumnGrid>
				<div>
					<FormControl
						label={
							<label
								className={
									requiredFields.includes("hiringManagerName") ? "required" : ""
								}
							>
								Hiring Manager name
							</label>
						}
						error={fieldErrors.hiringManagerName}
					>
						<Input
							value={hiringManagerName}
							onChange={(e) => {
								setHiringManagerName(e.currentTarget.value);
							}}
						/>
					</FormControl>
				</div>
				<div>
					<FormControl
						label={
							<label
								className={
									requiredFields.includes("hiringManagerContactNumber")
										? "required"
										: ""
								}
							>
								Hiring Manager contact number
							</label>
						}
						error={fieldErrors.hiringManagerContactNumber}
					>
						<Input
							value={hiringManagerContactNumber}
							onChange={(e) => {
								setHiringManagerContactNumber(e.currentTarget.value);
							}}
						/>
					</FormControl>
				</div>
			</TwoColumnGrid>
			<FormControl
				label={
					<label
						className={requiredFields.includes("firstName") ? "required" : ""}
					>
						First name
					</label>
				}
				error={fieldErrors.firstName}
			>
				<Input
					value={firstName}
					onChange={(e) => {
						setFirstName(e.currentTarget.value);
					}}
				/>
			</FormControl>
			<FormControl
				label={
					<label
						className={requiredFields.includes("lastName") ? "required" : ""}
					>
						Last name
					</label>
				}
				error={fieldErrors.lastName}
			>
				<Input
					value={lastName}
					onChange={(e) => {
						setLastName(e.currentTarget.value);
					}}
				/>
			</FormControl>
			<FormControl
				label={
					<label
						className={
							requiredFields.includes("contactEmail") ? "required" : ""
						}
					>
						Email
					</label>
				}
				error={fieldErrors.contactEmail}
			>
				<Input
					value={contactEmail}
					onChange={(e) => {
						setContactEmail(e.currentTarget.value);
					}}
				/>
			</FormControl>
			<FormControl label={"Mobile phone number"}>
				<Input
					value={contactMobile}
					onChange={(e) => {
						setContactMobile(e.currentTarget.value);
					}}
				/>
			</FormControl>
			<hr />
{/*
 			<FormControl label={"Who are they replacing?"}>
				<Input
					value={replacingName}
					onChange={(e) => {
						setReplacingName(e.currentTarget.value);
					}}
				/>
			</FormControl>
			<FormControl label={"Has that person been terminated?"}>
				<Checkbox
					checked={replacingTerminated}
					onChange={() => {
						setReplacingTerminated(!replacingTerminated);
					}}
				/>
			</FormControl>
			<hr />
*/}

			<TwoColumnGrid>
			<div>
				<FormControl
							label={
								<label
									className={
										requiredFields.includes("position") ? "required" : ""
									}
								>
									Which position are they being employed for?
								</label>
							}
							error={fieldErrors.position}
						>
						<>
							<Select
								required
								options={allPositions.map((position: any) => {
									return {
										value: position.name,
										label: position.name,
									};
								})}
								labelKey={"label"}
								valueKey={"value"}
								maxDropdownHeight="12rem"
								value={position}
								clearable={false}
								onChange={(params) => {
									setPosition(params.value);
								}}
							/>
						</>
					</FormControl>
				</div>
{/* 				<div>
					<FormControl
						label={
							<label
								className={
									requiredFields.includes("position") ? "required" : ""
								}
							>
								Which position are they being employed for?
							</label>
						}
						error={fieldErrors.position}
					>
						<>
							<Select
								labelKey={"label"}
								valueKey={"value"}
								maxDropdownHeight="12rem"
								clearable={false}
								options={enums.jobPosition}
								value={position}
								onChange={(params) => {
									if (params && params.value) {
										setPosition(params.value);
									}
								}}
							/>
						</>
					</FormControl>
				</div>
*/}
				<div>
					<FormControl
						label={
							<label
								className={
									requiredFields.includes("positionDescriptionValue")
										? "required"
										: ""
								}
							>
								Which Job Description should be used?
							</label>
						}
						error={fieldErrors.positionDescriptionValue}
					>
						<>
							<Select
								labelKey={"name"}
								valueKey={"id"}
								options={allPositionDescriptions}
								maxDropdownHeight="12rem"
								clearable={false}
								value={positionDescriptionValue}
								onChange={(params) => {
									setPositionDescriptionValue(params.value);
								}}
							/>
							{positionDescriptionValue &&
								positionDescriptionValue.length == 1 && (
									<a
										href={positionDescriptionValue[0].fileLink}
										target="_blank"
									>
										<br />
										Download Job Description
									</a>
								)}
						</>
					</FormControl>
				</div>
				<div>
					<FormControl label="Will the person be driving a company vehicle?">
						<Checkbox
							checked={drivingCompanyVehicle}
							onChange={() => {
								let currentValue = drivingCompanyVehicle;
								setDrivingCompanyVehicle(!drivingCompanyVehicle);

								if (!currentValue) {
									const drivingAgreementSetId =
										allOnboardingTaskSets.items.filter((item: any) => {
											return item.code === "driving-policy";
										})[0].identifier;

									if (selectedTaskSets.indexOf(drivingAgreementSetId) < 0) {
										let tmpSelectedTaskSets = [...selectedTaskSets];
										tmpSelectedTaskSets.push(drivingAgreementSetId);
										setSelectedTaskSets(tmpSelectedTaskSets);
									}
								}
							}}
						/>
					</FormControl>
					{drivingCompanyVehicle && (
						<Notification>
							Remember to update{" "}
							<ol>
								<li>
									The{" "}
									<a
										href={
											appContext.state.settings.VehicleScheduleSheet ??
											"about:blank"
										}
										target="_blank"
										rel="noopener"
									>
										Vehicle Schedule Sheet
									</a>
								</li>
								<li>
									The{" "}
									<a
										href={
											appContext.state.settings.DriverCheckScheduleSheet ??
											"about:blank"
										}
										target="_blank"
										rel="noopener"
									>
										Driver Check Schedule Sheet
									</a>{" "}
									(so their details can be added to NZTA)
								</li>
							</ol>
						</Notification>
					)}
				</div>
				<div>
					<FormControl label="Will the person have travel allowance?">
						<Checkbox
							checked={vehicleAllowancePolicy}
							onChange={() => {
								let currentValue = vehicleAllowancePolicy;
								setVehicleAllowancePolicy(!vehicleAllowancePolicy);

								if (!currentValue) {
									const drivingAgreementSetId =
										allOnboardingTaskSets.items.filter((item: any) => {
											return item.code === "travel-allowance";
										})[0].identifier;

									if (selectedTaskSets.indexOf(drivingAgreementSetId) < 0) {
										let tmpSelectedTaskSets = [...selectedTaskSets];
										tmpSelectedTaskSets.push(drivingAgreementSetId);
										setSelectedTaskSets(tmpSelectedTaskSets);
									}
								}
							}}
						/>
					</FormControl>
				</div>				
			</TwoColumnGrid>

			<TwoColumnGrid>
				<div>
					<FormControl
						label={
							<label>Hourly Rate</label>
						}
					>
						<Input
								startEnhancer="$"
								value={hourlyRate}
								onChange={(e) => {
									// const currentValue = JSON.parse(
									// 	JSON.stringify(hourlyRate)
									// );
									let newValue = parseFloat(
										parseFloat(e.currentTarget.value).toFixed(2)
									);
									setHourlyRate(!newValue? 0 : newValue);
								}}
								type="number"
								min={0}
							/>
					</FormControl>
				</div>
				<div>
					<FormControl
						label={
							<label>Salary</label>
						}
					>
						<Input
								startEnhancer="$"
								value={salary}
								onChange={(e) => {
									let newValue = parseFloat(
										parseFloat(e.currentTarget.value).toFixed(0)
									);
									setSalary(!newValue? 0 : newValue);
								}}
								type="number"
								min={0}
							/>
					</FormControl>
				</div>
				{/* <div>
					<FormControl
						label={
							<label
								className={
									requiredFields.includes("hourlyRate") ? "required" : ""
								}
							>
								Hourly Rate?
							</label>
						}
						error={fieldErrors.hourlyRate}
					>
						{jobCodeRates && (
							<StyledSelect
								labelKey={"jobCodeRate"}
								valueKey={"jobCodeRate"}
								options={jobCodeRates}
								maxDropdownHeight="12rem"
								clearable={true}
								value={customHourlyRate ? 0 : hourlyRate}
								disabled={customHourlyRate}
								onChange={(params) => {
									setHourlyRate(params.value);
								}}
							/>
						)}
					</FormControl>
				</div>
				<div>
					<FormControl label="Custom hourly rate required">
						<Checkbox
							checked={customHourlyRate}
							onChange={() => {
								setCustomHourlyRate(!customHourlyRate);
							}}
						/>
					</FormControl>
				</div> */}
			</TwoColumnGrid>

			<FormControl
				label={
					<label
						className={requiredFields.includes("workRegion") ? "required" : ""}
					>
						Work Region
					</label>
				}
				error={fieldErrors.workRegion}
			>
				<>
					<RadioGroup
						value={workRegion}
						onChange={(e) => setWorkRegion(e.currentTarget.value)}
						align={ALIGN.horizontal}
					>
						{enums.WorkRegions &&
							enums.WorkRegions.map((WorkRegions: any) => {
								return (
									<Radio value={WorkRegions.value}>{WorkRegions.label}</Radio>
								);
							})}
					</RadioGroup>
				</>
			</FormControl>
			<FormControl
				label={
					<label
						className={
							requiredFields.includes("employmentTypeValue") ? "required" : ""
						}
					>
						Employment type
					</label>
				}
				error={fieldErrors.employmentTypeValue}
			>
				<>
					<Select
						labelKey={"label"}
						valueKey={"value"}
						maxDropdownHeight="12rem"
						clearable={false}
						options={
							isWorkingHoliday
								? enums.employmentType.filter(
										(etype: { label: string }) => etype.label != "Permanent"
								  )
								: enums.employmentType
						}
						value={employmentTypeValue}
						onChange={(params) => {
							if (params && params.value) {
								setEmploymentTypeValue(params.value);
							}
						}}
					/>
				</>
			</FormControl>
			<TwoColumnGrid>
				{allEmploymentAgreements &&
					allEmploymentAgreements.length > 0 &&
					allEmploymentAgreements.map((employmentAgreement: any) => {
						return (
							<>
								<div>
									<FormControl
										label={`Offer ${employmentAgreement.name}`}
										caption={employmentAgreement.notes}
										overrides={{
											Label: {
												style: () => ({
													opacity: isWorkingHoliday
														? holidayVisaEmploymentAgreements.indexOf(
																employmentAgreement.identifier
														  ) > -1
															? "1"
															: "0.3"
														: "1",
												}),
											},
											Caption: {
												style: () => ({
													opacity: isWorkingHoliday
														? holidayVisaEmploymentAgreements.indexOf(
																employmentAgreement.identifier
														  ) > -1
															? "1"
															: "0.3"
														: "1",
												}),
											},
										}}
									>
										<>
											<Checkbox
												checked={
													availableEmploymentAgreements.indexOf(
														employmentAgreement.identifier
													) > -1 ? 
														// ? workRegion == "Southern" &&
														//   employmentAgreement.name.includes("AWUNZ")
														// 	? false
														// 	: true
														true
														: false
												}
												onChange={() => {
													let tmpAvailableEmploymentAgreements = [
														...availableEmploymentAgreements,
													];

													if (
														tmpAvailableEmploymentAgreements.indexOf(
															employmentAgreement.identifier
														) > -1
													) {
														tmpAvailableEmploymentAgreements.splice(
															tmpAvailableEmploymentAgreements.indexOf(
																employmentAgreement.identifier
															),
															1
														);
													} else {
														tmpAvailableEmploymentAgreements.push(
															employmentAgreement.identifier
														);
													}

													setAvailableEmploymentAgreements(
														tmpAvailableEmploymentAgreements
													);
												}}
												disabled={
													isWorkingHoliday
														? holidayVisaEmploymentAgreements.indexOf(
																employmentAgreement.identifier
														  ) > -1
															? false
															: true
														: false
												}
											/>
										</>
									</FormControl>
								</div>

								{employmentAgreement.slug ==
									"individual-employment-agreement" && <div> </div>}
							</>
						);
					})}
			</TwoColumnGrid>
			<FormControl
				label={<label>Reason for Fixed Term Employment Agreement</label>}
			>
				<Input
					value={reasonForAgreement}
					onChange={(e) => {
						setReasonForAgreement(e.currentTarget.value);
					}}
				/>
			</FormControl>
			<FormControl
				label={<label>Company Benefits</label>}
			>
				<Textarea
					value={companyBenefit}
					placeholder="Recommend to put in point form here..."
					onChange={(e) => {
						setCompanyBenefit(e.currentTarget.value);
					}}
				/>
			</FormControl>
			<FormControl
				label={
					<label
						className={
							requiredFields.includes("approvedByRegionalManager")
								? "required"
								: ""
						}
					>
						Approved by (HR Manager)
					</label>
				}
				error={fieldErrors.approvedByRegionalManager}
			>
				<Input
					value={approvedByRegionalManager}
					onChange={(e) => {
						setApprovedByRegionalManager(e.currentTarget.value);
					}}
				/>
			</FormControl>
			<hr />
			{/* {candidateSites.map((candidateSite: CandidateSite) => {
				return (
					<>
						{candidateSite.siteId > 0 && <hr />}
						<FormControl
							label={
								<label
									className={
										requiredFields.includes(
											`candidateSites[${candidateSite.siteId - 1}].jobCode`
										)
											? "required"
											: ""
									}
								>
									{`Site ${candidateSite.siteId} - Job Code`}
								</label>
							}
							error={getSiteJobCodeError(candidateSite.siteId - 1)}
						>
							{jobCodes && (
								<StyledSelect
									labelKey={"jobCodeName"}
									valueKey={"jobCode"}
									options={jobCodes}
									maxDropdownHeight="12rem"
									clearable={true}
									value={jobCodes.find(
										(jc: { jobCode: string }) =>
											jc.jobCode === candidateSite.jobCode
									)}
									onChange={(params) => {
										let sites = candidateSites.slice();
										sites[candidateSite.siteId - 1].jobCode =
											params.option?.jobCode;
										setCandidateSites(sites);
									}}
									getOptionLabel={getLabel}
									getValueLabel={getLabel}
								/>
							)}
						</FormControl>
						<TwoColumnGrid>
							<div>
								<FormControl
									label={
										<label
											className={
												candidateSite.customHourlyRate == false &&
												requiredFields.includes(
													`candidateSites[${
														candidateSite.siteId - 1
													}].jobCodeRate`
												)
													? "required"
													: ""
											}
										>
											{`Site ${candidateSite.siteId} - Hourly Rate`}
										</label>
									}
									error={
										candidateSite.customHourlyRate == false &&
										getSiteJobCodeRateError(candidateSite.siteId - 1)
									}
								>
									{jobCodeRates && (
										<StyledSelect
											labelKey={"jobCodeRate"}
											valueKey={"jobCodeRate"}
											options={jobCodeRates}
											maxDropdownHeight="12rem"
											clearable={true}
											value={jobCodeRates.filter(
												(jc: { jobCodeRate: number }) =>
													jc.jobCodeRate == candidateSite.jobCodeRate
											)}
											disabled={candidateSite.customHourlyRate}
											onChange={(params) => {
												let sites = candidateSites.slice();
												sites[candidateSite.siteId - 1].jobCodeRate =
													params.option?.jobCodeRate;
												setCandidateSites(sites);
											}}
										/>
									)}
								</FormControl>
							</div>
							<div>
								<FormControl label="Custom hourly rate required">
									<Checkbox
										checked={candidateSite.customHourlyRate}
										onChange={(e) => {
											let sites = [...candidateSites];
											sites[candidateSite.siteId - 1].customHourlyRate =
												e.currentTarget.checked;

											// Include or exclude reasonForOtherRate in requiredFields based on the checkbox state
											if (e.currentTarget.checked) {
												requiredFields.push(
													`candidateSites[${
														candidateSite.siteId - 1
													}].reasonForOtherRate`
												);
											} else {
												const indexToRemove = requiredFields.indexOf(
													`candidateSites[${
														candidateSite.siteId - 1
													}].reasonForOtherRate`
												);
												if (indexToRemove !== -1) {
													requiredFields.splice(indexToRemove, 1);
												}
											}

											setCandidateSites(sites);
										}}
									/>
								</FormControl>
							</div>
						</TwoColumnGrid>
						{candidateSite.customHourlyRate && (
							<TwoColumnGrid>
								<div>
									<FormControl
										label={
											<label
												className={
													candidateSite.customHourlyRate &&
													requiredFields.includes(
														`candidateSites[${
															candidateSite.siteId - 1
														}].jobCodeRate`
													)
														? "required"
														: ""
												}
											>
												{`Site ${candidateSite.siteId} - Custom Hourly Rate?`}
											</label>
										}
										error={
											candidateSite.customHourlyRate &&
											getSiteJobCodeRateError(candidateSite.siteId - 1)
										}
									>
										<Input
											startEnhancer="$"
											value={candidateSite.jobCodeRate}
											onChange={(e) => {
												let sites = candidateSites.slice();
												sites[candidateSite.siteId - 1].jobCodeRate =
													parseFloat(e.currentTarget.value);
												setCandidateSites(sites);
											}}
											type="number"
											min={0}
										/>
									</FormControl>
								</div>
								<div>
									<FormControl
										label={
											<label
												className={
													requiredFields.includes(
														`candidateSites[${
															candidateSite.siteId - 1
														}].reasonForOtherRate`
													)
														? "required"
														: ""
												}
											>
												{`Site ${candidateSite.siteId} - Reason for Custom Rate`}
											</label>
										}
										error={getSiteReasonForCustomRateError(
											candidateSite.siteId - 1
										)}
									>
										<Input
											value={candidateSite.reasonForOtherRate}
											onChange={(e) => {
												let sites = candidateSites.slice();
												sites[candidateSite.siteId - 1].reasonForOtherRate =
													e.currentTarget.value;
												setCandidateSites(sites);
											}}
										/>
									</FormControl>
								</div>
							</TwoColumnGrid>
						)}
						<div>
							<FormControl
								label={`Site ${candidateSite.siteId}  Hours per day, exclusive of meal break (total paid hours)`}
							>
								<SiteDaysContainer>
									<div>
										<FormControl label="Monday">
											<Input
												type="number"
												min={0}
												value={candidateSite.mondayHours}
												endEnhancer="hours"
												onChange={(e) => {
													let sites = candidateSites.slice();
													sites[candidateSite.siteId - 1].mondayHours =
														parseFloat(e.currentTarget.value);
													setCandidateSites(sites);
												}}
											/>
										</FormControl>
									</div>
									<div>
										<FormControl label="Tuesday">
											<Input
												type="number"
												min={0}
												value={candidateSite.tuesdayHours}
												endEnhancer="hours"
												onChange={(e) => {
													let sites = candidateSites.slice();
													sites[candidateSite.siteId - 1].tuesdayHours =
														parseFloat(e.currentTarget.value);
													setCandidateSites(sites);
												}}
											/>
										</FormControl>
									</div>
									<div>
										<FormControl label="Wednesday">
											<Input
												type="number"
												min={0}
												value={candidateSite.wednesdayHours}
												endEnhancer="hours"
												onChange={(e) => {
													let sites = candidateSites.slice();
													sites[candidateSite.siteId - 1].wednesdayHours =
														parseFloat(e.currentTarget.value);
													setCandidateSites(sites);
												}}
											/>
										</FormControl>
									</div>
									<div>
										<FormControl label="Thursday">
											<Input
												type="number"
												min={0}
												value={candidateSite.thursdayHours}
												endEnhancer="hours"
												onChange={(e) => {
													let sites = candidateSites.slice();
													sites[candidateSite.siteId - 1].thursdayHours =
														parseFloat(e.currentTarget.value);
													setCandidateSites(sites);
												}}
											/>
										</FormControl>
									</div>
									<div>
										<FormControl label="Friday">
											<Input
												type="number"
												min={0}
												value={candidateSite.fridayHours}
												endEnhancer="hours"
												onChange={(e) => {
													let sites = candidateSites.slice();
													sites[candidateSite.siteId - 1].fridayHours =
														parseFloat(e.currentTarget.value);
													setCandidateSites(sites);
												}}
											/>
										</FormControl>
									</div>
									<div>
										<FormControl label="Saturday">
											<Input
												type="number"
												min={0}
												value={candidateSite.saturdayHours}
												endEnhancer="hours"
												onChange={(e) => {
													let sites = candidateSites.slice();
													sites[candidateSite.siteId - 1].saturdayHours =
														parseFloat(e.currentTarget.value);
													setCandidateSites(sites);
												}}
											/>
										</FormControl>
									</div>
									<div>
										<FormControl label="Sunday">
											<Input
												type="number"
												min={0}
												endEnhancer="hours"
												value={candidateSite.sundayHours}
												onChange={(e) => {
													let sites = candidateSites.slice();
													sites[candidateSite.siteId - 1].sundayHours =
														parseFloat(e.currentTarget.value);
													setCandidateSites(sites);
												}}
											/>
										</FormControl>
									</div>
								</SiteDaysContainer>
							</FormControl>
						</div>
					</>
				);
			})}
			<Button
				kind="secondary"
				onClick={() => {
					addCandidateSiteFields(candidateSites.length);
					setCandidateSites([
						...candidateSites,
						{
							jobCodeRate: hourlyRate,
							siteId: candidateSites.length + 1,
							customHourlyRate: false,
						} as CandidateSite,
					]);
				}}
			>
				Add another site
			</Button> 
			<hr />*/}

			<FormControl
				/**label={
					<label
						className={requiredFields.includes("daysOfWorkPerWeek") ? "required" : ""}
					>
						Days of work per week
					</label>
				}
				error={fieldErrors.daysOfWorkPerWeek}**/
				label={<label>Days of work per week (Note: This is required for Fix or Permanent employment)</label>}
			>
				<Input
					type="number"
					min={0}
					max={7}
					value={daysOfWorkPerWeek}
					onChange={(e) => {
						setDaysOfWorkPerWeek(parseInt(e.currentTarget.value));
					}}
				/>
			</FormControl>

			<FormControl
				/**label={
					<label
						className={requiredFields.includes("hoursOfWorkPerDay") ? "required" : ""}
					>
						Hours of work per day
					</label>
				}
				error={fieldErrors.hoursOfWorkPerDay}**/
				label={<label>Hours of work per day (Note: This is required for Fix or Permanent employment)</label>}
			>
				<Input
					type="number"
					min={0}
					max={7}
					value={hoursOfWorkPerDay}
					onChange={(e) => {
						setHoursOfWorkPerDay(parseInt(e.currentTarget.value));
					}}
				/>
			</FormControl>

			<FormControl
				label={
					<label
						className={requiredFields.includes("timeOfWork") ? "required" : ""}
					>
						Time of work (e.g. 8am-4:30pm)
					</label>
				}
				error={fieldErrors.timeOfWork}
			>
				<Input
					value={timeOfWork}
					onChange={(e) => {
						setTimeOfWork(e.currentTarget.value);
					}}
				/>
			</FormControl>
			<FormControl
				label={
					<label
						className={requiredFields.includes("basedAt") ? "required" : ""}
					>
						Base Office (e.g. PPCS Head Office)
					</label>
				}
				error={fieldErrors.basedAt}
			>
				<Input
					value={basedAt}
					onChange={(e) => {
						setBasedAt(e.currentTarget.value);
					}}
				/>
			</FormControl>
			<FormControl
				label={<label>Work Tool(s) (e.g. Laptop/Mobile)</label>}
			>
				<Input
					value={workTool}
					onChange={(e) => {
						setWorkTool(e.currentTarget.value);
					}}
				/>
			</FormControl>
			<hr />
			{/* <FormControl label="Required in excess of 10 hours per day?">
				<Checkbox
					checked={requiredInExcessOf10HoursPerDay}
					onChange={() => {
						setRequiredInExcessOf10HoursPerDay(
							!requiredInExcessOf10HoursPerDay
						);
					}}
				/>
			</FormControl> */}

<FormControl
				label="Start date"
				caption="If start date is known, subject to clean MOJ Report and acceptance"
			>
				<div>
					<Datepicker
						onChange={({ date }) => {
							if (Array.isArray(date)) {
								setStartDate(date[0]);
							} else {
								setStartDate(date);
							}
						}}
						value={startDate}
						formatString="d MMMM yyyy"
						placeholder=" "
						mask={null}
					/>
				</div>
			</FormControl>

			<FormControl
				label="Fixed Term End Date"
				caption="Fixed term end date is only for fixed term employment agreement"
			>
				<div>
					<Datepicker
						onChange={({ date }) => {
							setFixedTermEndDate(Array.isArray(date) ? date : [date]);
						}}
						value={fixedTermEndDate}
						formatString="d MMMM yyyy"
						placeholder=" "
						mask={null}
					/>
				</div>
			</FormControl>

			<FormControl
				label={
					<label
						className={requiredFields.includes("managerName") ? "required" : ""}
					>
						Supervisor / Manager Name
					</label>
				}
				error={fieldErrors.managerName}
			>
				<Input
					value={managerName}
					onChange={(e) => {
						setManagerName(e.currentTarget.value);
					}}
				/>
			</FormControl>
			<FormControl
				label={
					<label
						className={
							requiredFields.includes("managerContactNumber") ? "required" : ""
						}
					>
						Supervisor / Manager Contact Number
					</label>
				}
				error={fieldErrors.managerContactNumber}
			>
				<Input
					value={managerContactNumber}
					onChange={(e) => {
						setManagerContactNumber(e.currentTarget.value);
					}}
				/>
			</FormControl>

			<hr />
			<FormControl label={"Which onboarding tasks should be allocated?"}>
				<>
					{allOnboardingTaskSets && allOnboardingTaskSets.items && (
						<GridSpacer>
							{allOnboardingTaskSets.items.map((item: any, i: number) => {
								return (
									<div>
										<Checkbox
											checked={selectedTaskSets.includes(item.identifier)}
											onChange={() => {
												let tmpSelectedTaskSets = [...selectedTaskSets];

												if (tmpSelectedTaskSets.includes(item.identifier)) {
													tmpSelectedTaskSets.splice(
														tmpSelectedTaskSets.indexOf(item.identifier),
														1
													);
												} else {
													tmpSelectedTaskSets.push(item.identifier);
												}
												setSelectedTaskSets(tmpSelectedTaskSets);
											}}
										>
											{item.label}
										</Checkbox>
									</div>
								);
							})}
						</GridSpacer>
					)}
				</>
			</FormControl>

			<hr />
			<FormControl
				label={
					<label
						className={requiredFields.includes("allocatedTo") ? "required" : ""}
					>
						Allocate To
					</label>
				}
				error={fieldErrors.allocatedTo}
			>
				<>
					{adminUsers && (
						<StyledSelect
							labelKey={"name"}
							valueKey={"id"}
							options={adminUsers}
							maxDropdownHeight="12rem"
							clearable={false}
							//value={adminUsers[0]}
							value={allocatedTo}
							onChange={(params) => {
								setAllocatedTo(params.value);
							}}
						/>
					)}
				</>
			</FormControl>

			<hr />
			<FormControl
				label={
					<label
						className={
							requiredFields.includes("ppcsConfirmed") ? "required" : ""
						}
					>
						Do you confirm that all details loaded into this form are correct?
					</label>
				}
				error={fieldErrors.ppcsConfirmed}
			>
				<Checkbox
					checked={ppcsConfirmed}
					onChange={() => {
						setPpcsConfirmed(!ppcsConfirmed);
					}}
				/>
			</FormControl>
			<br />
			<br />
			<Button onClick={validateAndSave} isLoading={isSaving}>
				Edit Candidate
			</Button>
			{/* {candidateCreated && (
				<Modal
					closeable={false}
					isOpen={candidateCreated}
					animate
					autoFocus
					role="dialog"
				>
					<ModalHeader>
						{firstName} {lastName} Created
					</ModalHeader>
					<ModalBody>
						A temporary password has been set. This will last for seven days.
						When you close this window, these details will be lost
						<br />
						<br />
						Username: <Input value={contactEmail} /> <br />
						Password:{" "}
							<Input type="password" value={candidate.temporaryPassphrase} />					
						<br />
						<br />
							<a href={candidate.onboardingPackUrl} target="_blank">
							Download Onboarding Pack for Printing
							</a>
					</ModalBody>
					<ModalFooter>
						<ModalButton onClick={allDone}>Okay</ModalButton>
					</ModalFooter>
				</Modal>
			)} */}
		</Container>
	);
	}
};
export default CandidateEdit;
